/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    string, object, bool, oneOfType,
} from 'prop-types';
import ReactHTMLParser from 'react-html-parser';
import { isEmpty } from '../../utils/object';

const ErrorInline = (props) => {
    // eslint-disable-next-line object-curly-newline
    const { error, customClass, isReadyState, name } = props;
    if (
        (typeof error === 'string' && !error)
        || (typeof error === 'object' && isEmpty(error))
        || !isReadyState
    ) {
        return null;
    }
    if ((error.name || name) && error.name !== name) return null;
    let errorMessage;
    if (typeof error === 'string') {
        errorMessage = error;
    } else {
        errorMessage = error.message ? error.message : error.errorMessage;
    }
    if (errorMessage === 'No Data') errorMessage = '';
    if (error && error.type && error.type !== 'inline') errorMessage = '';
    return errorMessage ? (
        <div className={`error-inline ${customClass}`}>
            {ReactHTMLParser(errorMessage)}
        </div>
    ) : (
        ''
    );
};

ErrorInline.defaultProps = { customClass: '', error: '', name: '' };

ErrorInline.propTypes = {
    error: oneOfType([string, object]),
    customClass: string,
    isReadyState: bool.isRequired,
    name: string,
};

export default ErrorInline;
